import axios from 'axios';
import { GOOGLE_MAPS_API_KEY_VREFYD, BangloreLocationBias } from '../../constants/app-constants';

let internals = {};

// Standardized wrapper for Google Places v1 autocomplete POST
internals.placesAutocompleteV1 = function ({
  input,
  includedRegionCodes = ['in'],
  locationRestriction = {
    circle: {
      center: {
        latitude: BangloreLocationBias.center.lat,
        longitude: BangloreLocationBias.center.lng,
      },
      radius: BangloreLocationBias.radius,
    },
  },
}) {
  return axios.post(
    'https://places.googleapis.com/v1/places:autocomplete',
    {
      input,
      includedRegionCodes,
      locationRestriction,
    },
    {
      headers: {
        accept: 'application/json, text/plain, */*',
        'content-type': 'application/json',
        'x-goog-api-key': GOOGLE_MAPS_API_KEY_VREFYD,
      },
    }
  );
};

export default internals;


